<template>
  <div>
    <p v-if="challenge.count_unfinished_retries == 0 && !challenge.finished_at">
      Você deveria ter concluído até {{ cycle.end_challenge_apply | moment('DD/MM/y') }}
    </p>
    <p v-if="challenge.count_unfinished_retries > 0 && challenge.retry_is_expired">
      Você deveria ter concluído até {{ challenge.retry_valid_until | moment('DD/MM/y') }}
    </p>
    <p v-if="challenge.count_unfinished_retries > 0 && !challenge.retry_is_expired">
      Seu desafio foi reaberto e ficará disponível até {{ $moment(challenge.retry_valid_until).format('DD/MM/YYYY HH:mm') }}
    </p>
  </div>
</template>

<script>

export default {
  props: {
    challenge: {
      type: Object,
      required: true
    },
    cycle: {
      type: Object,
      required: true
    },
  },
  
}
</script>
